import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "item more prev-more-button",
  style: {"width":"2.2em"}
}
const _hoisted_2 = {
  key: 2,
  class: "item more next-more-button",
  style: {"width":"2.2em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "pagination",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["item prev-button", {disabled: _ctx.currentPage === 1}])
    }, "❮", 2),
    (_ctx.pageCount > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["item page", {active: _ctx.currentPage === 1}])
        }, "1", 2))
      : _createCommentVNode("", true),
    (_ctx.showPrevMore)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagers, (pager) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["item page", {active: _ctx.currentPage === pager}]),
        key: pager
      }, _toDisplayString(pager), 3))
    }), 128)),
    (_ctx.showNextMore)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.pageCount > 1)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass(["item page", {active: _ctx.currentPage === _ctx.pageCount}])
        }, _toDisplayString(_ctx.pageCount), 3))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["item next-button", {disabled: _ctx.currentPage === _ctx.pageCount}])
    }, "❯", 2)
  ], 512)), [
    [_vShow, !_ctx.hideOnSinglePage || _ctx.pageCount > 1]
  ])
}